export default __webpack_public_path__ + "static/media/carnival2.db9501c9.jpeg";